import {
  insuranceCardResponseSchema,
  type InsuranceCardResponse,
  type InsuranceCardView,
} from "@/src/models/insurance-card-view";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getInsuranceCard(
  patientId: string,
  coverageId: string,
  departmentId?: string | null
): Promise<InsuranceCardView | null> {
  const trimmedDepartmentId = departmentId?.trim();
  const searchParams = new URLSearchParams();

  if (trimmedDepartmentId) {
    searchParams.set("departmentId", trimmedDepartmentId);
  }

  const query = searchParams.toString();
  const response = await fetchJSON<InsuranceCardResponse>(
    `/api/patients/${encodeURIComponent(patientId)}/coverages/${encodeURIComponent(coverageId)}/insurance-card${
      query ? `?${query}` : ""
    }`,
    trimmedDepartmentId
      ? {
          headers: {
            "x-athena-department-id": trimmedDepartmentId,
          },
        }
      : undefined
  );

  return insuranceCardResponseSchema.parse(response).card;
}
